__turbopack_context__.v({
  "categoryHeader": "l1_vaq_categoryHeader",
  "container": "l1_vaq_container",
  "glossaryHeader": "l1_vaq_glossaryHeader",
  "header": "l1_vaq_header",
  "headerHits": "l1_vaq_headerHits",
  "highlight": "l1_vaq_highlight",
  "hit": "l1_vaq_hit",
  "hitDescription": "l1_vaq_hitDescription",
  "hitTitle": "l1_vaq_hitTitle",
  "icon": "l1_vaq_icon",
  "noShrink": "l1_vaq_noShrink",
  "pageText": "l1_vaq_pageText",
  "relatedHit": "l1_vaq_relatedHit",
  "route": "l1_vaq_route",
  "routeAndText": "l1_vaq_routeAndText",
  "schemaText": "l1_vaq_schemaText",
  "selected": "l1_vaq_selected",
  "separator": "l1_vaq_separator",
  "view": "l1_vaq_view",
});
